import React from "react";
import Typed from "typed.js";

export default function AutoType() {
  const el = React.useRef(null);
  const typed = React.useRef(null);

  React.useEffect(() => {
    const options = {
      strings: [
        "Hi!",
        "My name is <b style=\"color:#2dd4bf\">Aritra Bhattacharjee</b>",
        "I build <b style=\"color:#fbbf24\">Python tools</b>",
        "I craft <b style=\"color:#2dd4bf\">Web apps</b>",
        "I explore <b style=\"color:#fbbf24\">Machine Learning</b>",
      ],
      typeSpeed: 50,
      backSpeed: 40,
      loop: true,
    };

    typed.current = new Typed(el.current, options);

    return () => {
      typed.current.destroy();
    };
  }, []);

  return (
    <span className="wrap">
      <div className="type-wrap">
        <span style={{ whiteSpace: "pre" }} ref={el} />
      </div>
    </span>
  );
}
